export enum SourceId {
  Europe = 6,
  Belarus = 1,
  Russia = 3,
  USA = 4,
}
